export class ContactChannelDef {
    public ChannelTypeId!: number;
    public ChannelTypeName!: string;
    public ChannelType!: string;
    public EntryAmount!: string;
}
